import React from "react";

/** Бекенд қоңырау тарихын чатқа `[voice_call:<status>:<секунд>]` белгісімен
 *  жазады (status ∈ completed | missed | declined). Бұрын панельде осы белгі
 *  өңделмей, жай мәтін болып тұратын. */
const VOICE_CALL_RE = /^\s*\[voice_call:([a-z_]+):(\d+)\]\s*$/;

export const parseVoiceCall = (text) => {
  const m = VOICE_CALL_RE.exec(text || "");
  return m ? { status: m[1], seconds: Number(m[2]) } : null;
};

const duration = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

/** «Қоңырау · 0:18», «Жауапсыз қоңырау», «Қабылданбаған қоңырау». */
export const voiceCallLabel = (call, t) => {
  if (call.status === "completed") return `${t("call.completed")} · ${duration(call.seconds)}`;
  if (call.status === "declined") return t("call.declined");
  return t("call.missed");
};

/** `**қалың**` — ЖИ көмекшісі мен дайын жауаптар markdown-пен жазады;
 *  бұрын жұлдызшалар мәтін болып көрінетін. Қалғанын өзгертпейміз. */
export const renderBold = (text, keyPrefix = "b") =>
  String(text)
    .split(/(\*\*[^*\n]+\*\*)/g)
    .map((part, i) =>
      /^\*\*[^*\n]+\*\*$/.test(part) ? (
        <strong key={`${keyPrefix}${i}`} className="font-semibold">
          {part.slice(2, -2)}
        </strong>
      ) : (
        part
      ),
    );

/** Тізімдегі алдын ала көрініс үшін markdown белгілерін алып тастау. */
export const stripBold = (text) => String(text || "").replace(/\*\*([^*\n]+)\*\*/g, "$1");
